import "./load-more-button.scss";

import Loading from "@frontend/js/Components/Shared/Loading/Loading";
import PlusIcon from "@frontend/images/icons/PlusIcon";
import { useState } from "react";
import axios from "axios";
import { route } from "ziggy-js";

export default function LoadMoreButton({
    label = "Mai încarcă",
    onClick = null,
    isLoading = false,
    disabled = false,
    collection = null,
    locale = null,
    routeName = null,
    onLoaded = null,
    pageSlug = null,
    category = null,
}) {
    const [internalLoading, setInternalLoading] = useState(false);

    const pagination = collection?.meta
        ? {
              current_page: collection.meta.current_page,
              last_page: collection.meta.last_page,
              per_page: collection.meta.per_page,
              total: collection.meta.total,
              has_more_pages:
                  collection.meta.current_page < collection.meta.last_page,
          }
        : null;

    const handleClick = async () => {
        if (onClick) {
            onClick();
            return;
        }

        if (!pagination?.has_more_pages || internalLoading || isLoading) return;

        setInternalLoading(true);
        const nextPage = pagination.current_page + 1;

        try {
            const url = route(routeName);
            const { data } = await axios.post(url, {
                locale,
                page: nextPage,
                per_page: pagination.per_page,
                page_slug: pageSlug,
                category,
            });

            if (onLoaded) {
                // Handle ResourceCollection response: data.data contains the actual items array
                const items = Array.isArray(data.data)
                    ? data.data
                    : data.data?.data || [];

                const newPagination = data.meta
                    ? {
                          current_page: data.meta.current_page,
                          last_page: data.meta.last_page,
                          per_page: data.meta.per_page,
                          total: data.meta.total,
                          has_more_pages:
                              data.meta.current_page < data.meta.last_page,
                      }
                    : null;
                onLoaded(items, newPagination);
            }
        } catch (error) {
            console.error("Error loading more:", error);
        } finally {
            setInternalLoading(false);
        }
    };

    const isButtonLoading = isLoading || internalLoading;

    if (isButtonLoading) {
        return (
            <div className="loadMoreButton" aria-live="polite" aria-busy="true">
                <Loading size={48} className="loadMoreButton__spinner" />
            </div>
        );
    }

    return (
        <div className="loadMoreButton">
            <button
                className="loadMoreButton__button"
                onClick={handleClick}
                disabled={disabled || isButtonLoading}
                aria-busy={isButtonLoading}
            >
                {label}
                <PlusIcon className="loadMoreButton__button__icon" />
            </button>
        </div>
    );
}
